module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-image-ead23808.svg";